<button class="btn btn-filter btn-toggle h-full" [matMenuTriggerFor]="filterFeatureMenu"
    [ngClass]="{ 'active': selectedItems().length > 0 }">
    <app-svg
        [ngClass]="selectedItems().length === 1 && (valueToIconMap[selectedItems()[0]] == 'habit' || valueToIconMap[selectedItems()[0]] == 'journal' || valueToIconMap[selectedItems()[0]] == 'list') ? 'icon-mirror-rtl' : ''"
        [name]="selectedItems().length === 1 ? valueToIconMap[selectedItems()[0]] : 'feature'"
        [color]="selectedItems().length > 0 ? ss.theme().color12 : ss.theme().color7" class="me-2"
        style="height: 17px; width: 17px;"></app-svg>
    <span>{{ getLabel() }}</span>
    <div class="clear-icon ri-ms-2" *ngIf="selectedItems().length > 0" role="button"
        (click)="selectedItems.set([]); value.set([]);$event.stopPropagation()">
        <app-svg class="d-flex align-items-center justify-content-center" name="close"
            [color]="ss.theme().color1"></app-svg>
    </div>
</button>

<mat-menu yPosition="above" xPosition="before" #filterFeatureMenu="matMenu" class="me-menu ri-w-350px">
    <ng-container *ngFor="let status of entityFilterFeature; let i = index;">
        <button mat-menu-item *ngIf="!hiddenValues.includes(status)" (click)="onFeatureSelected(status, $event)">
            <span class="text-14-400 color-8 flex items-center justify-between">
                <div class="flex items-center">
                    <app-svg [name]="valueToIconMap[status]"
                        [ngClass]="valueToIconMap[status] == 'todo' || valueToIconMap[status] == 'moneyTracker' ? '' : 'icon-mirror-rtl'"
                        [color]="ss.theme().color35" class="ri-me-4" width="18px" height="18px"></app-svg>
                    <span>{{ entityFeatureMap()[status] }}</span>
                </div>
                <app-input-checkbox [checked]="selectedItems().includes(status)"></app-input-checkbox>
            </span>
        </button>
    </ng-container>
</mat-menu>